import { render, staticRenderFns } from "./donutChart.vue?vue&type=template&id=50b40762&lang=pug&"
import script from "./donutChart.vue?vue&type=script&lang=js&"
export * from "./donutChart.vue?vue&type=script&lang=js&"
import style0 from "./donutChart.vue?vue&type=style&index=0&id=50b40762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports